var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75a.75.75 0 0 0 1.085.671l1.469-.735a3.174 3.174 0 0 1 3.665.595.75.75 0 0 0 .946.094l.823-.549a3.165 3.165 0 0 1 3.521 0l.823.549a.747.747 0 0 0 .946-.094 3.17 3.17 0 0 1 3.664-.595l1.47.735A.75.75 0 0 0 21.747 12c0-5.376-4.374-9.75-9.75-9.75zm-7.866 8.344-.287.145a8.269 8.269 0 0 1 6.669-6.853 15.885 15.885 0 0 0-2.197 6.72 4.667 4.667 0 0 0-4.184-.012zM12 10.04c-.746 0-1.489.189-2.17.548A14.383 14.383 0 0 1 12 4.316a14.383 14.383 0 0 1 2.17 6.272A4.655 4.655 0 0 0 12 10.04zm7.865.554a4.662 4.662 0 0 0-4.183.011 15.899 15.899 0 0 0-2.197-6.72 8.27 8.27 0 0 1 6.669 6.853l-.288-.145z",
    opacity: 1,
    "data-original": "#112d55",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M12 21.073a.744.744 0 0 1-.53-.22l-2.774-2.774c-.513-.512-.795-1.192-.795-1.917s.282-1.405.795-1.918a2.717 2.717 0 0 1 3.305-.413 2.721 2.721 0 0 1 3.305.413c.513.513.795 1.193.795 1.918s-.282 1.405-.795 1.917l-2.774 2.774a.748.748 0 0 1-.53.22zm-1.388-6.122a1.2 1.2 0 0 0-.856.354c-.229.229-.355.533-.355.857s.126.628.355.856L12 19.262l2.244-2.244c.229-.229.355-.533.355-.856s-.126-.628-.355-.857a1.213 1.213 0 0 0-1.714 0 .75.75 0 0 1-1.061 0 1.21 1.21 0 0 0-.857-.354z",
    opacity: 1,
    "data-original": "#549bff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.54922f866002e7ab1556f7c12b31a97e.svg";
export { ForwardRef as ReactComponent };